<template>
	<div class="mod-config">
		<el-card :style="getCardHeight()">
			<el-row style="margin: -5px 10px 8px 5px;font-size: 15px;font-weight: bolder;">监理通知单</el-row>
			<el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="115px" class="border-form">
				<el-row class="set_border" v-show="showSubject">
					<el-col :span="24">
						<el-form-item label="标的物" prop="subjectNoList" class="item">
							<el-select v-model="dataForm.subjectNoList" placeholder="" class="no-border-input" multiple
								clearable>
								<el-option v-for="(item, index) in subjectList" :key="index" :label="item.displayName"
									:value="item.displayValue">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :class="getContactClass()">
					<el-col :span="12">
						<el-form-item label="承包单位" prop="contractCompany" class="item">
							<el-input v-model="dataForm.contractCompany" placeholder=""
								class="no-border-input"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="合同号" prop="contactNo" class="item">
							<el-input v-model="dataForm.contactNo" placeholder="" class="no-border-input"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row class="set_border">
					<el-col :span="12">
						<el-form-item label="监理单位" prop="companyName" class="item">
							<el-input v-model="dataForm.companyName" class="no-border-input"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="编号" prop="fileNo" class="item">
							<el-input v-model="dataForm.fileNo" class="no-border-input"></el-input>
							<!-- <span style="margin-left: 10px;">{{ dataForm.fileNo }}</span> -->
						</el-form-item>
					</el-col>
				</el-row>
				<el-row class="set_border">
					<el-col :span="12">
						<el-form-item label="工程名称" prop="projectName" class="item">
							<el-input class="no-border-input" v-model="dataForm.projectName"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="工作控制号" class="item">
							<span style="margin-left: 15px;font-size: small;">{{ dataForm.workNo }}</span>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row class="set_border">
					<el-col :span="12">
						<el-form-item label="致" prop="dispObject" class="item">
							<el-input class="no-border-input" v-model="dataForm.dispObject"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="日期" class="item" prop="dispDate">
							<el-date-picker class="no-border-input" v-model="dataForm.dispDate" type="date"
								value-format="yyyy-MM-dd" placeholder="选择日期">
							</el-date-picker>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row class="set_border">
					<el-col :span="24">
						<el-form-item label="抄送" prop="sendCopy" class="item">
							<el-input class="no-border-input" v-model="dataForm.sendCopy"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row class="form-title">
					<span>
						事由
					</span>
				</el-row>
				<el-row class="set_border">
					<el-col :span="24">
						<el-input type="textarea" :rows="4" v-model="dataForm.fileTitle"
							class="set_data no-border-input">
						</el-input>
					</el-col>
				</el-row>
				<el-row class="form-title">
					<span>
						内容
					</span>
				</el-row>
				<el-row class="set_border">
					<el-row v-for="(problem, index) in dataForm.problemList" :key="'problem' + index">
						<el-col :span="20" style="margin: 10px 0px 10px 100px;">
							<!-- <el-input v-model="problem.itemContext"></el-input> -->
							<span style="white-space: pre-line; display: block;">{{ problem.itemContext }}</span>
						</el-col>
						<el-col :span="2">
							<el-button v-preventReClick type="text" size="small"
								@click="addProblem('2', problem, index)">修改</el-button>
							<el-button v-preventReClick type="text" size="small"
								@click="delProblem(index)">删除</el-button>
						</el-col>
						<el-row class="photo_row">
							<el-col :span="23" style="width:90%;margin-left:25%">
								<div v-for="(photo, index1) in problem.photoList" :key="'ph' + index1"
									v-if="problem.photoList != undefined && problem.photoList.length > 0"
									:style="{ order: photo.showSort }">
									<el-col :span="10" class="photo_col">
										<!-- 在col内部添加相对定位 -->
										<div style="margin:20px 20px 20px 20px; position: relative; height: 100%;">
											<!-- 删除按钮 - 完全在照片上方，不接触照片 -->
											<div class="photo-delete-btn" @click="deletePhoto(index, index1)"
												title="删除照片">
												<i class="el-icon-close"></i>
											</div>

											<!-- 照片区域 -->
											<div style="margin-top: 30px;"><!-- 增加上边距，给按钮留出空间 -->
												<el-image style="height: 250px; width: 100%;"
													:src="photo.compressedPathUri" fit='contain'></el-image>
											</div>

											<!-- 照片描述输入框 -->
											<div class="t-column-ellipsis">
												<el-input v-model="photo.photoContext" placeholder="照片描述"></el-input>
											</div>
										</div>
									</el-col>
								</div>
							</el-col>
						</el-row>
					</el-row>
					<el-button v-preventReClick class="btn" type="primary" size="small" @click="addProblem('1')"
						style="margin: 5px;">添加内容段落</el-button>
				</el-row>
				<el-row class="set_border">
					<el-col :span="15">
						<el-form-item label="监理工程师" prop="dispMan" class="item">
							<el-input class="no-border-input" style="width: 90% !important;"
								v-model="dataForm.dispMan"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="9">
						<el-form-item label="时间" prop="dispTime" class="item">
							<el-date-picker class="no-border-input" style="width: 90% !important;"
								v-model="dataForm.dispTime" type="date" value-format="yyyy-MM-dd" placeholder="选择时间">
							</el-date-picker>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<el-row class="formBtnGroup" style="margin-top: 40px;">
				<div class="set_bg">
					<el-button v-preventReClick class="btn" type="primary" size="small"
						@click="dataFormSubmit()">保存</el-button>
					<el-button v-preventReClick class="rebtn" size="small" plain @click="goBack()">取消</el-button>
				</div>
			</el-row>
		</el-card>
		<problem-photo v-if="problemPhotoVisible" ref="problemPhoto"
			@problemPhotoItems="margeProblemPhotoItems"></problem-photo>
	</div>
</template>

<script>
import $common from "@/utils/common.js"
import ProblemPhoto from "./hqnotice-problem-photo.vue"
export default {
	name: "hqnotice-add-or-update",
	data() {
		return {
			visible: false,
			inline: false,
			showSubject: false,
			problemPhotoVisible: false,
			operateType: '',
			problemIndex: '',
			dataForm: {
				workNo: $common.getItem("workNo"),
				subjectNoList: [],
				executedFileType: '2',
				fileId: '',
				fileNo: '',
				showFileNo: '',
				fileTitle: '',
				fileContent: '',
				dispObject: '',
				dispDate: '',
				sendCopy: '',
				filePath: '',
				dispMan: '',
				dispTime: '',
				receiverName: '',
				remark: '',
				projectDirector: '',
				receiverOptions: '',
				receiveMan: '',
				receiveTime: '',
				handleOptions: '',
				closeMan: '',
				closeTime: '',
				projectName: '',
				contractCompany: '',
				companyName: '',
				problemList: [],
				contactNo: ''
			},
			subjectList: [],
			dataRule: {
				subjectNoList: [
					{ required: true, message: " ", trigger: "blur" }
				],
				fileNo: [
					{ required: true, message: " ", trigger: "blur" }
				],
				dispMan: [
					{ required: true, message: "请输入监理工程师", trigger: "blur" }
				],
				dispTime: [
					{ required: true, message: "请选择时间", trigger: "blur" }
				],
				dispObject: [
					{ required: true, message: " ", trigger: "blur" }
				]
			},
		}
	},
	components: {
		ProblemPhoto
	},
	mounted() {
		this.dataForm.fileId = this.$route.query.fileId
		this.dataForm.subjectNo = this.$route.query.subjectNo
		this.getInintHqNotice()
	},
	methods: {
		getCardHeight() {
			var height = this.$store.state.common.documentClientHeight - 75;
			return { minHeight: height + 'px' }
		},
		getCurrentTime() {
			//获取当前时间并打印
			var _this = this;
			let yy = new Date().getFullYear();
			let mm = new Date().getMonth() + 1;
			let dd = new Date().getDate();
			let hh = new Date().getHours();
			let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes();
			let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds();
			return yy + '-' + mm + '-' + dd;
		},
		getInintHqNotice() {
			this.dataForm = {
				workNo: $common.getItem("workNo"),
				subjectNoList: [],
				fileId: this.$route.query.fileId,
				subjectNo: this.$route.query.subjectNo,
				fileNo: '',
				showFileNo: '',
				fileTitle: '',
				fileContent: '',
				dispObject: '',
				dispDate: '',
				sendCopy: '',
				filePath: '',
				dispMan: $common.getItem("userName"),
				dispTime: this.getCurrentTime(),
				projectDirector: '',
				receiveMan: '',
				receiveTime: '',
				handleOptions: '',
				closeMan: '',
				closeTime: '',
				fileList: [],
				projectName: '',
				contractCompany: '',
				companyName: '',
				problemList: [],
				contactNo: ''
			};
			// 先获取标的物列表，再处理其他逻辑
			this.getSubjectDropDown().then(() => {
				if (this.dataForm.fileId) {
					this.$http({
						url: this.$store.state.httpUrl + `/business/noticeinfo/info/${this.dataForm.fileId}`,
						method: 'get',
						params: {}
					}).then(({ data }) => {
						if (data && data.resultCode === 200) {
							this.dataForm = data.body;
							this.$set(this.dataForm, "showFileNo", $common.getItem("workNo") + ' / ' + data.body.fileNo);
						}
					})
				} else {
					this.getInitNotice();
				}

				this.$nextTick(() => {
					this.visible = true;
					if (this.$refs["dataForm"] !== undefined) {
						this.$refs["dataForm"].resetFields();
					}

					// 设置默认选中的标的物
					if (this.dataForm.subjectNo) {
						let subjectNoList = []
						subjectNoList.push(this.dataForm.subjectNo)
						this.$set(this.dataForm, 'subjectNoList', subjectNoList)
					} else if (this.subjectList && this.subjectList.length > 0) {
						// 如果没有传入subjectNo，则默认选中第一个
						let subjectNoList = []
						subjectNoList.push(this.subjectList[0].displayValue)
						this.$set(this.dataForm, 'subjectNoList', subjectNoList)
					}
				});
			});
		},
		getSubjectDropDown() {
			return this.$http({
				url: this.$store.state.httpUrl + "/common/getSubjectDropDown/" + $common.getItem("workNo"),
				method: "get",
				params: {},
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.subjectList = data.body;
					if (this.subjectList != undefined && this.subjectList.length > 1) {
						this.showSubject = true
					} else {
						this.showSubject = false
					}
					return data.body;
				}
			});
		},
		getInitNotice() {
			this.$http({
				url: this.$store.state.httpUrl + `/business/noticeinfo/initNotice`,
				method: "GET",
				params: this.$http.adornParams({
					workNo: $common.getItem("workNo"),
					executedFileType: '2',
				})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.$set(this.dataForm, "projectName", data.body.projectName);
					this.$set(this.dataForm, "contractCompany", data.body.contractCompany);
					this.$set(this.dataForm, "companyName", data.body.companyName);
					this.$set(this.dataForm, "fileNo", data.body.fileNo);
					this.$set(this.dataForm, "dispMan", $common.getItem("userName"));
					this.$set(this.dataForm, "dispTime", this.getCurrentTime());
					this.$set(this.dataForm, "executedFileType", '2');
					this.$set(this.dataForm, "showFileNo", $common.getItem("workNo") + ' / ' + data.body.fileNo);
				}
			});
		},
		addProblem(operateType, problem, problemIndex) {
			this.operateType = operateType;
			this.problemIndex = problemIndex;
			this.problemPhotoVisible = true;
			this.$nextTick(() => {
				this.$refs.problemPhoto.init(this.dataForm.fileId, problem)
			})
		},
		extractFileName(fileName) {
			let index = fileName.lastIndexOf(".");
			return fileName.substr(0, index)
		},
		//表单提交
		dataFormSubmit() {
			this.dataForm.workNo = $common.getItem("workNo")
			this.dataForm.executedFileType = '2'
			if(!this.dataForm.subjectNoList || this.dataForm.subjectNoList.length === 0) {
				this.$message.error("请选择标的物！");
				return;
			}
			this.$refs["dataForm"].validate(valid => {
				if (valid) {
					let _url = "/business/noticeinfo/save";
					if (this.dataForm.fileId && this.dataForm.fileId != 0) {
						_url = "/business/noticeinfo/update";
					}
					this.$http({
						url: this.$store.state.httpUrl + _url,
						method: "post",
						data: this.$http.adornData(this.dataForm)
					}).then(({ data }) => {
						if (data && data.resultCode === 200) {
							this.$message({
								message: "操作成功",
								type: "success",
								duration: 1500,
								onClose: () => {
									this.$router.push({ name: 'hqnotice' });
								}
							});
						}
					});
				}
			});
		},
		goBack() {
			this.$router.back()
		},
		margeProblemPhotoItems(item) {
			if (this.dataForm.problemList == undefined || this.dataForm.problemList.length == 0) {
				this.dataForm.problemList = []
			}
			if (this.operateType == '1') {
				// 新增
				this.dataForm.problemList.push(item)
				this.$set(this.dataForm, "problemList", this.dataForm.problemList)
			} else {
				// 修改，替换
				let problemList = []
				for (var i = 0; i < this.dataForm.problemList.length; i++) {
					if (i != this.problemIndex) {
						problemList.push(this.dataForm.problemList[i])
					} else {
						problemList.push(item)
					}
				}
				this.$set(this.dataForm, "problemList", problemList)
			}
			// 清空
			this.operateType = ''
			this.problemIndex = ''
		},
		delProblem(index) {
			this.dataForm.problemList.splice(index, 1)
		},
		deletePhoto(index, index1) {
			this.dataForm.problemList[index].photoList.splice(index1, 1)
		},
		getContactClass() {
			if (this.showSubject) {
				return 'set_border'
			} else {
				return 'set_border_second'
			}
		}
	}
}
</script>
<style scoped lang="scss">
.selItemInput.descAreaLg {
	width: 640px !important;
}

.detail_input ::v-deep .el-input__inner {
	width: 560px !important;
}

.item_input ::v-deep .el-input__inner {
	width: 600px !important;
}

.photo_input ::v-deep .el-input__inner {
	width: 437px !important;
}

.file_input ::v-deep .el-input__inner {
	width: 100% !important;
}

.prob_btn {
	margin-left: -40px;
	position: absolute;
}

.upload-demo ::v-deep .el-upload-dragger {
	width: 300px;
	height: 100px;
	margin-left: 20px;
}

.upload-demo ::v-deep .el-upload-dragger .el-icon-upload {
	font-size: 40px;
	margin-top: 15px;
	line-height: 26px;
}

.upload-demo ::v-deep .el-upload-dragger .el-upload__text {
	line-height: 8px;
}

::v-deep .el-tabs__item.is-active {
	color: #1d1d86;
	background-color: #E1F1FF;
}

::v-deep .el-tabs__item:hover {
	color: #121213;
	background-color: #eceeed;
}

::v-deep .el-tabs--top .el-tabs__item.is-top {
	width: 134.5px;
	text-align: center;
}

.border {
	border: 1px solid #cbcbd3;
	height: 290px;
	width: 590px
}

::v-deep .el-input__inner {
	border: solid #dadada 1px;
}

.border-form .el-row.set_border {
	border-bottom: solid #dadada 1px;
	border-left: solid #dadada 1px;
	border-right: solid #dadada 1px;
}

.border-form .el-row.set_border_second {
	border-bottom: solid #dadada 1px;
	border-left: solid #dadada 1px;
	border-right: solid #dadada 1px;
	border-top: solid #dadada 1px;
}

.border-form .el-row.set_border:first-child {
	border-top: solid #dadada 1px;
}

::v-deep .el-form-item {
	/* display: flex !important; */
	align-items: stretch !important;
	margin-bottom: 0px !important;
}

.item::v-deep .el-form-item__label {
	color: #00428E !important;
	margin-right: 10px !important;
	font-weight: bold !important;
	background-color: #E1F1FF;
	white-space: nowrap !important;
	border-right: solid #dadada 1px;
}

.setcontact_item ::v-deep .el-form-item__label {
	margin-left: 2px !important;
	width: 93px !important;
	margin-bottom: 10px;
	background-color: #E1F1FF;
	color: #00428E !important;
	font-weight: bold !important;
}

.setsummary_item ::v-deep .el-form-item__label {
	margin-left: 2px !important;
	width: 93px !important;
	margin-bottom: 15px;
	background-color: #E1F1FF;
	color: #00428E !important;
	font-weight: bold !important;
}

.no-border-input.el-date-editor.el-date-editor--date {
	::v-deep .el-input__suffix {
		display: flex !important;
		align-items: center !important;
		justify-content: center !important;
		position: absolute !important;
		/* 必须加！否则right无效且图标易消失 */
		top: 50% !important;
		/* 垂直居中，避免图标偏移 */
		transform: translateY(-50%) !important;
		right: 5px !important;
		/* 你要的右侧5px间距 */
		width: auto !important;
		/* 取消固定宽度，避免容器遮挡 */
		height: 100% !important;
		/* 占满高度，确保点击生效 */
		pointer-events: auto !important;
		/* 保证图标可点击，避免失效 */
		z-index: 1 !important;
		/* 防止图标被遮挡 */
	}

	/* 隐藏左侧占位，不影响右侧图标 */
	::v-deep .el-input__prefix {
		display: none !important;
		width: 0 !important;
		padding: 0 !important;
		margin: 0 !important;
	}

	/* 补充：给输入框右侧留空间，避免文字遮挡图标 */
	::v-deep .el-input__inner {
		padding-right: 30px !important;
		/* 适配5px右侧间距，留出图标空间 */
		padding-left: 15px !important;
		/* 重置左侧内边距，消除空白 */
		border-radius: 0 !important;
		// border: 1px solid #dadada !important;
	}
}

.no-border-input ::v-deep .el-input__inner {
	border: none !important;
}

.no-border-input ::v-deep .el-textarea__inner {
	border: none !important;
}

.form-title {
	background-color: #E1F1FF;
	color: #00428E;
	font-weight: bold !important;
	padding: 10px;
	border: solid #dadada 1px;
	border-top: 0px;
}

.set_data {
	margin-top: 1px;
}

.photo_row {
	// border: 1px solid rgba(235, 238, 240, 1);
	width: 80%;
	padding-bottom: 20px;
	padding-top: 20px;
	margin-top: 10px
}

.photo_col {
	border: 1px solid rgba(235, 238, 240, 1);
}

.photo-delete-btn {
	position: absolute;
	top: -25px;
	/* 负值让按钮完全在容器顶部外面 */
	right: 0;
	width: 24px;
	height: 24px;
	background-color: #ffffff;
	color: #333333;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	z-index: 10;
	transition: all 0.3s ease;
	font-size: 14px;
}

.photo-delete-btn:hover {
	color: black;
	transform: scale(1.1);
}

/* 或者想要更明显一点的样式 */
.photo-delete-btn-prominent {
	position: absolute;
	top: -30px;
	/* 更靠上 */
	right: -5px;
	/* 稍微偏右 */
	width: 28px;
	height: 28px;
	border-radius: 50%;
	background-color: #f0f0f0;
	color: #666666;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	z-index: 10;
	transition: all 0.3s ease;
	border: 1px solid #cccccc;
	box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
	font-size: 16px;
	font-weight: bold;
}

/* 确保照片区域有足够的上边距 */
.photo_col div[style*="margin:20px"] {
	padding-top: 10px;
	/* 给按钮留出空间 */
}

.no-border-input {
	width: 90% !important;

	&.el-select,
	&.el-date-editor.el-date-editor--date {
		width: 90% !important;
	}
}

.set_bg {
	padding-top: 10px;
	width: 65%;
	height: 50px;
	bottom: 6px;
	position: fixed;
	left: 25%;
	background-color: #f7f1f1;
}
</style>
